// extracted by mini-css-extract-plugin
module.exports = {"center-btn":"MapDialog_center-btn__-CeAY","right-btn":"MapDialog_right-btn__20suH"};